import React from 'react'

import {colors} from "../../utils/styles"
import DigitalBigRadio from "./DigitalBigRadio"
import {displaySprintPayOption} from "../../utils/util"

const optionBoxStyle = {minWidth: 300}
const optionTextStyle = {fontSize: '16px', color: colors.mocText}
const rowStyle = {
  display: 'flex',
  flexDirection: 'row',
  padding: 10,
  borderBottom: 'solid 1px ' + colors.mocBorders
}
const liStyle = {marginTop: 7}
const ulType = {fontSize: '16px', marginTop: 10, paddingLeft: 60, listStyleType: 'disc'}
const infoHeaderStyle = {fontSize: '14px', fontWeight: 700, color: colors.mocText}
const infoParaStyle = {fontSize: '14px', color: colors.mocText}

const DigitalPaymentOption = (props) => {
  const handleOptionClick = (option) => {
    if (props.onChange) {
      props.onChange(option)
    }
  }

  const msg = "To proceed, you can either utilize your existing PayCargo account credentials, create a new " +
    "PayCargo account or process a one-time payment with PayCargo’s Ship & Pay feature."

  const forCosco = props.userProfile?.forCosco
  let payCargoLabel
  if (forCosco){
    payCargoLabel = <div>
      Pay Now with PayCargo<div style={{color: colors.red}}>for real time release of cargo</div>
    </div>
  } else {
    payCargoLabel ='Pay Now with PayCargo'
  }

  return (
    <div style={{fontFamily: 'Inter', border: 'solid 0.25px #d8d8d8'}} className="payment-info">
      <div style={{
        height: 35, width: '100%',
        fontWeight: 400, fontSize: 16,
        backgroundColor: colors.mocTableHeaderBg,
        color: colors.grayDark,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        filter: 'drop-shadow(0 1px 3px rgba(11, 11, 13, 0.25))'
      }}>
        <div style={{
          marginLeft: 20,
          fontSize: 14,
          fontWeight: 700
        }}>PAYMENT OPTION</div>
      </div>
      <div style={rowStyle}>
        <div style={optionBoxStyle}>
          <DigitalBigRadio label={payCargoLabel}
                    selected={props.option === 'Pay Now'}
                    onClick={() => handleOptionClick('Pay Now')}/>
        </div>
        {/* For COSCO, hide the text when offline option is selected to make room for address info*/}
        <div style={optionTextStyle}>{(props.option !== 'Pay Offline' || !forCosco) &&
          <span>This option provides an expedited cargo release (30-90 minutes once payment is submitted).
            The system will generate an invoice number and it will allow you to pay on this platform.
            <b>{msg}</b> In addition, when choosing this option, you should complete payment in a timely manner.</span>
        }
        </div>
      </div>
      {displaySprintPayOption() &&
      <div style={rowStyle}>
        <div style={optionBoxStyle}>
          <DigitalBigRadio label={'Pay Now with SprintPay'}
                    selected={props.option === 'Pay Now SP'}
                    onClick={() => handleOptionClick('Pay Now SP')}/>
        </div>
        <div style={optionTextStyle}>
          <span>This option is for SprintPay.</span>
        </div>
      </div>
      }
      <div style={rowStyle}>
        <div style={optionBoxStyle}>
          <DigitalBigRadio label={'Pay Later with PayCargo'}
                    selected={props.option === 'Pay Later'}
                    onClick={() => handleOptionClick('Pay Later')}/>
        </div>
        {/* For COSCO, hide the text when offline option is selected to make room for address info*/}
        <div style={optionTextStyle}>{(props.option !== 'Pay Offline' || !forCosco) &&
            <span>This option is suited for individuals that are not the payer but
          still want to confirm pick up date and generate an invoice. Please advise the demurrage payer to
          log in into Real Time Release and to complete the payment. Once payment is submitted via Real
          Time Release, the cargo will be released within 30-90 minutes.</span>
        }
        </div>
      </div>
      {displaySprintPayOption() &&
      <div style={rowStyle}>
        <div style={optionBoxStyle}>
          <DigitalBigRadio label={'Pay Later with SprintPay'}
                    selected={props.option === 'Pay Later SP'}
                    onClick={() => handleOptionClick('Pay Later SP')}/>
        </div>
        <div style={optionTextStyle}>
          <span>This option is suited for individuals that are not the payer but still want to confirm
            pick up date and generate an invoice. Please advise the demurrage payer to log in into Real
            Time Release and to complete the payment. Once payment is submitted via Real Time Release, ...
          </span>
        </div>
      </div>
      }
      <div style={rowStyle}>
        <div style={optionBoxStyle}>
          <DigitalBigRadio label={'Pay Offline'}
                    selected={props.option === 'Pay Offline'}
                    onClick={() => handleOptionClick('Pay Offline')}/>
          <ul style={ulType} className="small-disc-ul">
            <li style={liStyle}>Wire</li>
            <li style={liStyle}>ACH</li>
            <li style={liStyle}>Other 3rd Party Platform</li>
          </ul>
        </div>
        <div style={optionTextStyle}>
          {(props.option !== 'Pay Offline' || !forCosco) ?
              <span>This option does not provide a timely cargo release. The system will generate an invoice
                number and it will allow you to pay offline via ACH or Wire. <b>Note:</b> Prior to cargo
                release, {forCosco ? 'COSCO' : 'OOCL'} will confirm internally that monies
                have been received and posted into our system. Wire transactions and ACH are dependent on your
                financial institutions processing time, which could result in payment clearance delay and
                additional demurrage fees.
              </span> :
              <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gridGap: 20
              }}>
                <div>
                  <div style={infoHeaderStyle}>Houston Office Payment Information</div>
                  <div style={infoParaStyle}>Cheque Issue To: COSCO SHIPPING Lines (North America) Inc.<br/>
                    Wire Transfer Info: J.P. Morgan Chase Bank<br/>
                    Acct No. 722619616<br/>
                    ABA No. 021000021 ACH No. 111000614<br/>
                    Include Payment Details, Invoice or B/L Number, Your Contact Details<br/>
                  </div>
                </div>
                <div>
                  <div style={infoHeaderStyle}>Long Beach Office Payment Information</div>
                  <div style={infoParaStyle}>Cheque Issue To: COSCO SHIPPING Lines (North America) Inc.<br/>
                    Wire Transfer Info: JP Morgan Chase<br/>
                    Acct No. 304686867<br/>
                    ABA No. 021000021<br/>
                    Include Payment Details, Invoice or B/L Numbers, Your Contact Phone Number<br/>
                  </div>
                </div>
                <div>
                  <div style={infoHeaderStyle}>Houston Office Mailing Address</div>
                  <div style={infoParaStyle}>COSCO SHIPPING Lines (North America) Inc. Houston<br/>
                    15600 John F. Kennedy Blvd<br/>
                    Suite 400<br/>
                    Houston, TX 77032<br/>
                    Tel: 281-765-6800 Fax: 281-765-6801<br/>
                  </div>
                </div>                <div>
                  <div style={infoHeaderStyle}>Long Beach Office Mailing Address</div>
                <div style={infoParaStyle}>COSCO Shipping Lines (North America), Inc.<br/>
                  588 Harbor Scenic Way, 3rd Floor<br/>
                  Long Beach, CA 90802<br/>
                  Attention: Accounts Receivable Department<br/>
                  Tel: 1-866-502-6726 ext. 2939<br/>
                </div>
              </div>
              </div>
          }
        </div>
      </div>
    </div>
  )
}

export default DigitalPaymentOption